export const addMessage = (payload) => ({type: "ADD_MESSAGE", payload });

export const clearMessages = (payload) => ({ type: "CLEAR_MESSAGES", payload });